import type { AppStatusType } from '@/features/appStatus/types/appStatus';

export function normalizeStatusType(raw?: string | null): AppStatusType {
  const value = (raw || '').trim().toLowerCase().replace(/[\s_-]+/g, '');

  if (
    value.includes('maintain') ||
    value === 'maintenance' ||
    value === 'down'
  ) {
    return 'maintenance';
  }

  if (
    value.includes('issue') ||
    value.includes('incident') ||
    value.includes('outage') ||
    value.includes('problem')
  ) {
    return 'issue';
  }

  if (value.includes('demo') || value.includes('offer')) {
    return 'demo';
  }

  if (
    value.includes('launch') ||
    value.includes('comingsoon') ||
    value.includes('soon')
  ) {
    return 'launch';
  }

  return 'unknown';
}

export function statusEyebrow(type: AppStatusType): string {
  switch (type) {
    case 'maintenance':
      return 'Maintenance';
    case 'issue':
      return 'Service issue';
    case 'demo':
      return 'Demo';
    case 'launch':
      return 'Launching soon';
    default:
      return 'Notice';
  }
}
